// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2ErAZ","header":"Messages_header__3BBzr"};